import { useIsSubscriber } from '@batical/reducer/src'
import { useAuth } from 'src/contexts/AuthContext'

/**
 * Période d'accès premium offerte aux nouveaux comptes web, en jours.
 * Décomptée depuis la date de création du compte Firebase (`metadata.creationTime`).
 */
export const WEB_PREMIUM_GRACE_DAYS = 2

/**
 * Premium côté web : vrai abonné OU compte créé il y a moins de WEB_PREMIUM_GRACE_DAYS jours.
 * À utiliser pour les gates de features (RequireSubscription, etc.) — pas pour l'affichage
 * du statut d'abonnement (SubscriptionPage), qui doit refléter la réalité Stripe.
 */
export function useIsWebPremium(): boolean {
  const isSubscriber = useIsSubscriber()
  const { user } = useAuth()

  if (isSubscriber) return true
  if (!user) return false

  const creationIso = user.metadata?.creationTime
  if (!creationIso) return false
  const creationMs = Date.parse(creationIso)
  if (Number.isNaN(creationMs)) return false

  const ageMs = Date.now() - creationMs
  const graceMs = WEB_PREMIUM_GRACE_DAYS * 24 * 60 * 60 * 1000
  return ageMs >= 0 && ageMs < graceMs
}
